// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"TopArea-primaryButton-31q7uE","topArea":"TopArea-topArea-i2IiCi","appSearch":"TopArea-appSearch-33Ni9c"};